/* eslint-disable */

// Pending - connection code not redeemed.
// Enrolled - connected (connection code redeemed) but not recorded an ECG (study period not started basically).
// Active - study period started but not completed.
// Completed - study period ended.
// Expired - not connected and the connection code is revoked.

export const EnrollmentIDTFConnectionStatusEnum = {
  PENDING: 'Pending',
  ENROLLED: 'Enrolled',
  ACTIVE: 'Active',
  COMPLETED: 'Completed',
  COMPLETE: 'Complete',
  EXPIRED: 'Expired',
};
Object.freeze(EnrollmentIDTFConnectionStatusEnum);

export const getEnrollmentConnectionStatusesOrder = () => [
  EnrollmentIDTFConnectionStatusEnum.PENDING,
  EnrollmentIDTFConnectionStatusEnum.ENROLLED,
  EnrollmentIDTFConnectionStatusEnum.ACTIVE,
  EnrollmentIDTFConnectionStatusEnum.COMPLETED,
  EnrollmentIDTFConnectionStatusEnum.EXPIRED,
];


// WEBPACK FOOTER //
// ./src/views/constsnts/enrollmentIDTFStatus.js